import { CartAndLineItemGroups, CommerceToolsCart } from '@/types/commercetools';
import { ActiveCoupon } from './promos';

export const getCartCoupons = (cart: CommerceToolsCart | undefined | null): string[] =>
  cart?.custom?.fields?.sprdVoucherList?.split(',').filter(Boolean) ?? [];

export const mergeCouponCodes = (...lists: string[][]): string[] => [...new Set(lists.flat())];

// Coupons to validate (multi-coupon variant), in activation order: coupons only on the cart first
// (applied directly, e.g. the POTM coupon, so usually earlier), then the active ones from the
// cookie in the order they were activated. Promo coupons from the cookie only count where
// `includePromoCoupons` is set.
export const getCouponCandidates = (
  cartAndLineItemGroups: CartAndLineItemGroups | null | undefined,
  activeCoupons: ActiveCoupon[],
  includePromoCoupons: boolean
): string[] => {
  const activeCodes = activeCoupons
    .filter((coupon) => includePromoCoupons || coupon.source === 'url')
    .map((coupon) => coupon.code);
  // every cart coupon stays a candidate; those also active move to their activation position
  const cartOnlyCoupons = getCartCoupons(cartAndLineItemGroups?.cart).filter(
    (code) => !activeCodes.includes(code)
  );

  return mergeCouponCodes(cartOnlyCoupons, activeCodes);
};
